import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useInsuranceNumberInput } from "@/hooks/user-info-form/useInsuranceNumberInput";

export function InsuranceNumberInput() {
  const { user, errors, t, handleChange, handleBlur } = useInsuranceNumberInput();

  return (
    <div className="space-y-2">
      <Label className={"text-base"} htmlFor="insuranceNumber">{t("userInfoForm.insuranceNumber")}</Label>
      <Input
        id="insuranceNumber"
        value={user?.insuranceNumber || ""}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={(e) => handleBlur(e.target.value)}
        placeholder={t("userInfoForm.insuranceNumberPlaceholder")}
        className={errors.insuranceNumber ? "border-red-500" : ""}
      />
      {errors.insuranceNumber && <p className="text-sm text-red-500 mt-1">{errors.insuranceNumber}</p>}
    </div>
  );
}
